import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../translations';

import { ReceptionServiceUpdateForm } from './ReceptionServiceUpdateForm';
import { ReceptionServiceUpdateFormLoader } from './ReceptionServiceUpdateForm.loader';
import { ReceptionServiceUpdateAction } from './ReceptionServiceUpdateModal.actions';

type ReceptionServiceUpdateModalProps = {
   readonly onSuccess: VoidFunction;
   readonly receptionServiceId: ReceptionServiceId;
   readonly onClose: VoidFunction;
};

export const ReceptionServiceUpdateModal = (props: ReceptionServiceUpdateModalProps): JSX.Element => {
   return (
      <Modal
         testId={'receptionServiceUpdate'}
         title={receptionServiceTranslationKeys.update.modal.title}
         width={ModalWidth.HUGE}
      >
         <ReceptionServiceUpdateFormLoader id={props.receptionServiceId}>
            {({ practitioners, receptionService, serviceLocations }) => (
               <ReceptionServiceUpdateForm
                  receptionService={receptionService}
                  practitioners={practitioners}
                  serviceLocations={serviceLocations}
               >
                  {({ handleSubmit, formState, setNotUniqueReceptionServiceNameError }) => (
                     <>
                        <ReceptionServiceUpdateAction
                           onSuccess={props.onSuccess}
                           onReceptionServiceAlreadyExistsFault={setNotUniqueReceptionServiceNameError}
                        >
                           {({ updateReceptionService }) => (
                              <ModalConfirmButton
                                 label={receptionServiceTranslationKeys.update.modal.confirm}
                                 onClick={handleSubmit(updateReceptionService)}
                                 variant={ButtonVariant.PRIMARY}
                              />
                           )}
                        </ReceptionServiceUpdateAction>
                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.onClose}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </ReceptionServiceUpdateForm>
            )}
         </ReceptionServiceUpdateFormLoader>
      </Modal>
   );
};
